import { render, staticRenderFns } from "./AllBankruptcySubmissions.vue?vue&type=template&id=3c020285&scoped=true&"
import script from "./AllBankruptcySubmissions.vue?vue&type=script&lang=js&"
export * from "./AllBankruptcySubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllBankruptcySubmissions.vue?vue&type=style&index=0&id=3c020285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c020285",
  null
  
)

export default component.exports